import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import { FieldType, FormField } from '@shared/shared/form-fields';
import { FormFieldsInstanceService } from '../../services/form-fields-instance.service';
import { registerTranslationsManually } from '@skyeng/libs/shared/i18n';
import { TranslocoService } from '@ngneat/transloco';

export class PromptDialogData {
  title?: string | null;
  content?: string | null;
  no?: string;
  yes?: string;
  selectButton?: 'yes' | 'no';
  fieldType?: FieldType;
  fieldName?: string;
  fieldValue?: any;
}

@Component({
  templateUrl: './prompt-dialog.component.html',
  providers: [FormFieldsInstanceService],
})
export class PromptDialogComponent implements OnInit {
  form: UntypedFormGroup;
  promptField: FormField;

  constructor(
    @Inject(MAT_DIALOG_DATA) @Optional() public data: PromptDialogData = {},
    private formFields: FormFieldsInstanceService,
    private translocoService: TranslocoService,
  ) {}

  ngOnInit(): void {
    this.registerTranslations();
    this.setupData();
    this.initForm();
  }

  private registerTranslations(): void {
    registerTranslationsManually('promptDialog', this.translocoService, import.meta.webpackContext!('./translation'));
  }

  private setupData(): void {
    this.data = {
      ...{
        title: '',
        content: null,
        no: this.translocoService.translate('promptDialog.promptDialog.cancel'),
        yes: this.translocoService.translate('promptDialog.promptDialog.yes'),
        selectButton: 'yes',
        fieldType: FieldType.text,
        fieldName: '',
      },
      ...this.data,
    };
  }

  private initForm(): void {
    this.promptField = {
      key: 'promptField',
      type: this.data.fieldType,
      name: this.data.fieldName,
      value: this.data.fieldValue,
      validators: {
        required: true,
      },
    };
    this.form = this.formFields.getForm();
    this.formFields.setFields([this.promptField]);
  }
}
